import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash.merge';
import RaisedButton from 'material-ui/RaisedButton';
import * as styles from './Button.scss';
import { connect } from 'react-redux';
var SecondaryButton = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(SecondaryButton, _Component);

  var _super = _createSuper(SecondaryButton);

  function SecondaryButton() {
    _classCallCheck(this, SecondaryButton);

    return _super.apply(this, arguments);
  }

  _createClass(SecondaryButton, [{
    key: "render",
    value: function render() {
      console.warn("<SecondaryButton /> is a connected component. Either ensure this component has access to the Redux Provider or, if you do not need this to be Redux connected, consider using Material UI's built in <RaisedButton primary />.");
      var style = merge({}, {
        borderRadius: 4,
        minWidth: 120
      }, this.props.style);
      var shortButtonStyle = merge({}, {
        height: 28,
        lineHeight: '28px'
      }, this.props.buttonStyle);

      var cleanProps = _objectSpread({}, this.props);

      delete cleanProps.theme;
      delete cleanProps.shortButton;
      delete cleanProps.store;
      return /*#__PURE__*/React.createElement(RaisedButton, _extends({}, cleanProps, {
        backgroundColor: this.props.theme.colors.secondaryColor,
        buttonStyle: this.props.shortButton ? shortButtonStyle : this.props.buttonStyle,
        className: styles.button,
        fullWidth: true,
        secondary: true,
        style: style
      }));
    }
  }]);

  return SecondaryButton;
}(Component), _defineProperty(_class2, "propTypes", {
  style: PropTypes.object,
  buttonStyle: PropTypes.object.isRequired,
  shortButton: PropTypes.bool,
  theme: PropTypes.object
}), _defineProperty(_class2, "defaultProps", {
  label: 'Submit',
  style: {},
  type: 'submit',
  buttonStyle: {}
}), _temp)) || _class);
export { SecondaryButton as default };